import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import { SALES_GROUP } from '../../fields';
import { SALES_GROUP_VIDEO_REPORT_ID } from './salesGroupVideoReportId';

const reportFooterColumnDefinition = [SALES_GROUP].map(createFooterMapper(SALES_GROUP_VIDEO_REPORT_ID));

export default reportFooterColumnDefinition;
